import React, { useMemo } from "react";
import {
  CalenderIcon,
  CarIcon,
  SeatIcon,
  TimeIcon,
  WithoutCarIcon,
} from "../../../../helper/HwIconExcursion";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { UserGroupIcon } from "../../../../helper/HwIcon";
import { formatDateFormat } from "../../../../helper/commonFunction";

export const ExcursionCard = ({
  data,
  loading,
  variationId,
  date,
  time,
  persons,
  transfer,
  variationTitle,
  id,
}) => {
  const title = useMemo(() => {
    return (
      data?.singleExcursionData?.excursion_variations?.find?.((d) => {
        return String(d?.variation_unique_id) === String(variationId);
      })?.variation_title ?? data?.singleTitle
    );
  }, [data?.singleId, data?.singleExcursionData, variationId]);

  const hasTimeSlot =
    !!time &&
    /\d{1,2}:\d{2}/.test(String(time)) &&
    moment.parseZone(time).isValid();
  const timeFormated = hasTimeSlot
    ? moment.parseZone(time).format("HH:mm A")
    : "";
  return (
    <div className="hw-passenger--listShow__widget">
      {loading ? (
        <Skeleton height={"180px"} />
      ) : (
        <div className="row">
          <div className="col-lg-3 hw-img--col120">
            <div className="hw-img--holder hw-img--holder105">
              <img src={data?.singleThumbnail} alt="My Image" width="105" />
            </div>
          </div>
          <div className="col-lg-9 hw-car--listShow__passangerCol">
            <h3 class="mb-0 h4">{data?.singleTitle}</h3>
            <div className="hw-fontWeight--500 hw-blue hw-text14">
              {variationTitle ?? title}
            </div>
            <div className="hw-car--listShow__passangerColInner">
              <div className="middle-content--rowItem">
                <CalenderIcon />
                {/* {moment(date).format("DD/MM/YYYY")} */}
                {formatDateFormat(date)}
              </div>
              { !hasTimeSlot || timeFormated === "00:00 AM" || timeFormated === "00:00 PM" ? null : (
                <div className="middle-content--rowItem">
                  <TimeIcon />
                  {timeFormated}
                </div>
              )}
              <div className="middle-content--rowItem">
               <WithoutCarIcon/>
                {data?.excursionTransfer?.[transfer] ?? transfer}
              </div>
            </div>
            <hr />
            <div className="d-flex align-items-start hw-passenger--iconList">
              <UserGroupIcon />
              <div className="d-flex align-items-center flex-wrap">
                <span className="hw-blue hw-fontBold hw-text14">Persons:</span>
                <div className="d-flex flex-shrink-0">
                  <span>Adult: {persons?.[0] ?? "-"}</span>
                  <span>Child: {persons?.[1] ?? "-"}</span>
                  <span>Infant: {persons?.[2] ?? "-"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
